export default "__VITE_ASSET__Dicb5D4O__"